import { Box, type BoxProps } from '@mantine/core'
import { useEffect } from 'react'

import {
  type CoreBundle,
  type CoreItem,
  type CoreItemPhoto,
  type CoreItemPhotoPayload,
} from '@flecto/types'

import { BoxItemPhoto } from './BoxItemPhoto'
import classes from './styles.module.css'
import { useGridItemPhotosManagerState } from './useGridItemPhotosManagerState'

export type GridItemPhotosManagerProps = BoxProps & {
  product?: CoreItem | CoreBundle
  hasError?: boolean
  onChange?: (photos: CoreItemPhotoPayload[]) => void
}

export type ItemPhotoForManager = Omit<CoreItemPhoto, 'id'> &
  CoreItemPhotoPayload

export function GridItemPhotosManager({
  product,
  onChange,
  hasError = false,
  ...props
}: GridItemPhotosManagerProps) {
  const { photos, photosAttributes, initializeFromItem } =
    useGridItemPhotosManagerState()

  useEffect(() => {
    initializeFromItem(product)
  }, [])

  useEffect(() => {
    onChange?.(photosAttributes)
  }, [photosAttributes])

  return (
    <Box {...props} className={classes.gridPhotos}>
      {photos.map((photo, index) => {
        return (
          <BoxItemPhoto
            error={index === 0 && hasError}
            key={`photo-${index}`}
            data-testid={`box-photo-${index}`}
            product={product}
            photo={photo}
          />
        )
      })}
    </Box>
  )
}
